import { combineReducers, configureStore } from "@reduxjs/toolkit";
import AnswerBookletInDetailSlice from "./slices/AnswerBookletInDetailSlice";
import AnswerBookletPdfSlice from "./slices/AnswerBookletPdfSlice";
import AnswerHintPdfSlice from "./slices/AnswerHintPdfSlice";
import authSlice from "./slices/AuthSlice";
import changePasswordReducer from "./slices/ChangePasswordSlice";
import valuatorDashboardDetailSlice from "./slices/DashboardSlice";
import ValuatorBankDetail from "./slices/ValuatorBankDetailSlice";
import valuatorBookletRecord from "./slices/ValuatorBookletRecordSlice";
import valuatorDetail from "./slices/ValuatorDetailSlice";
import identityCardType from "./slices/ValuatorIdentityCardTypeSlice";
import valuatorIdentityDetail from "./slices/ValuatorIdentityDetailSlice";
import valuatorPersonalDetail from "./slices/ValuatorPersonDetailSlice";
import QuestionPaperPdfSlice from "./slices/QuestionPaperPdfSlice";
import pageNavigationSlice from "./slices/PageNavigationSlice";
import pageScoreSlice from "./slices/BookletScoreSlice"
import bookletAnnotatonsSlice from "./slices/BookletAnnotationsSlice"
import bookletSubmissionSlice from "./slices/BookletSubmissionSlice"
import networkReducer from "./slices/NetworkSlice";
import valuatedBookletSummary from "./slices/ValuatedBookletSummary";

const rootReducer = combineReducers({
	AnswerBookletInDetailSlice: AnswerBookletInDetailSlice,
	AnswerBookletPdfSlice: AnswerBookletPdfSlice,
	auth: authSlice,
	valuatorDetail: valuatorDetail,
	valuatorPersonalDetail: valuatorPersonalDetail,
	valuatorIdentityDetail: valuatorIdentityDetail,
	identityCardType: identityCardType,
	addValuatorBankDetail: ValuatorBankDetail,
	changePassword: changePasswordReducer,
	valuatorDashboardDetail: valuatorDashboardDetailSlice,
	valuatorBookletRecord: valuatorBookletRecord,
	QuestionPaperPdfSlice: QuestionPaperPdfSlice,
	AnswerHintPdfSlice: AnswerHintPdfSlice,
	pageNavigation: pageNavigationSlice,
	pageScore:pageScoreSlice,
	bookletAnnotations: bookletAnnotatonsSlice,
	bookletSubmission: bookletSubmissionSlice,
	network: networkReducer,
	valuatedBookletSummary:valuatedBookletSummary,
	
});

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});
